import * as React from 'react';
import SVGIcon from '../SVGIcon';

// tslint:disable:max-line-length
const ddd =
  'M1,1 L1,2.44444444 L18,2.44444444 L18,1 L1,1 Z M1,6.77777778 L1,8.22222222 L18,8.22222222 L18,6.77777778 L1,6.77777778 Z M1,12.5555556 L1,14 L18,14 L18,12.5555556 L1,12.5555556 Z';
// tslint:enable:max-line-length

const MobileOpenIcon: React.FC = () => {
  return (
    <SVGIcon viewBox="0 0 19 15">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path d={ddd} stroke="#FFFFFF" fill="#FFFFFF" fillRule="nonzero" />
      </g>
    </SVGIcon>
  );
};

export default MobileOpenIcon;
